import _ from "lodash";
import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import styled from "styled-components";
import StrikeZoneChart from "../components/StrikeZoneChart";
import PitchCriteria from "../components/filters/PitchCriteria";
import StrikeZoneModelCriteria from "../components/filters/StrikeZoneModelCriteria";
import ApplyButton from "../components/filters/ApplyButton";
import FilterSidebar from "../components/layout/FilterSidebar";
import rem from "../utils/rem";

const Wrapper = styled.div`
  display: flex;
  height: calc(100vh - ${rem(60)});
`;

const MainWrapper = styled.div`
  flex-grow: 1;
  margin-left: 25px;
`;

class StrikeZoneChartContainer extends Component {
  componentDidMount() {
    const {
      rootStore: { strikeZoneChartStore: store }
    } = this.props;
    if (_.isEmpty(store.setiData)) {
      store.fetchData();
    }
  }

  render() {
    const {
      rootStore: { strikeZoneChartStore: store }
    } = this.props;

    return (
      <Wrapper>
        <FilterSidebar>
          <PitchCriteria store={store} multiVenue />
          <StrikeZoneModelCriteria store={store} />
          <ApplyButton clickHandler={store.fetchData} />
        </FilterSidebar>
        <MainWrapper>
          <StrikeZoneChart data={store.setiData} isLoading={store.isLoading} />
        </MainWrapper>
      </Wrapper>
    );
  }
}

export default inject("rootStore")(observer(StrikeZoneChartContainer));



// WEBPACK FOOTER //
// ./src/containers/StrikeZoneChartContainer.js